var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-clamp',{attrs:{"tag":_vm.tag,"autoresize":_vm.autoresize,"max-lines":_vm.maxLines,"max-height":_vm.maxHeight,"ellipsis":_vm.ellipsis,"expanded":_vm.expanded},scopedSlots:_vm._u([{key:"after",fn:function(ref){
var expand = ref.expand;
var clamped = ref.clamped;
return [(clamped)?_c('span',{staticClass:"link",on:{"click":function (e) { return _vm.moreClick(e, expand); }}},[_vm._v(_vm._s(_vm.$t("more")))]):_vm._e()]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }